import * as React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Divider } from '@material-ui/core';

import classNames from 'classnames';
import _ from 'lodash';

import LabeledText from './LabeledText';
import friendlyNames, { type FriendlyOrdered } from './friendlyNames';

type Props = {
  nvpData?: Array<Object>,
  classes: any,
  className?: string,
  friendlyNames?: FriendlyOrdered,
  onlyFriendlyNames?: boolean,
  dividers?: boolean,
  dividerBefore?: boolean,
  dividerAfter?: boolean,
  dividerProps?: Object,
  keyProps?: Object,
  valueProps?: Object,
  itemProps?: Object,
  icon?: React.Node
};

function renderItem(
  nvpObject: Object,
  classes: Object,
  icon: any,
  keyProps: Object,
  valueProps: Object,
  itemProps: Object,
  dividers: boolean,
  dividerProps?: Object
) {
  let jsxReturn = undefined;

  const key: string = _.keys(nvpObject)[0];
  const val: any = nvpObject[key];

  jsxReturn = (
    <div key={key} className={classes.item} {...itemProps}>
      <LabeledText
        label={'' + key}
        labelProps={{ ...keyProps }}
        icon={icon}
        {...valueProps}
      >
        {'' + val}
      </LabeledText>
      {dividers && <Divider className={classes.divider} {...dividerProps} />}
    </div>
  );

  return jsxReturn;
}

// eslint-disable-next-line no-unused-vars
const NvpDisplay = (props: Props) => {
  const {
    nvpData = [],
    classes,
    className,
    keyProps = {},
    valueProps = {},
    itemProps = {},
    icon,
    friendlyNames: friendlyNamesProp,
    onlyFriendlyNames = true,
    dividers = false,
    dividerBefore = false,
    dividerAfter = false,
    dividerProps = {},
    ...otherProps
  } = props;

  const itemsToRender: Array<Object> = friendlyNames(
    friendlyNamesProp,
    onlyFriendlyNames
  ).applyToArray(nvpData);

  return (
    <div className={classNames(classes.root, className)} {...otherProps}>
      {dividers &&
        dividerBefore && (
          <Divider className={classes.divider} {...dividerProps} />
        )}
      {itemsToRender.map((obj, index, arr) =>
        renderItem(
          obj,
          classes,
          icon,
          keyProps,
          valueProps,
          itemProps,
          dividers && (dividerAfter || index < arr.length - 1),
          dividerProps
        )
      )}
    </div>
  );
};

const styles = ({
  spacing: { unit: spacing }
  //palette: { primary: primaryColorInfo }
}) => ({
  root: {
    width: '100%'
    //paddingBottom: spacing * 1
  },
  item: { marginTop: spacing * 1 },
  divider: {}
});

export default withStyles(styles)(NvpDisplay);
